import { render, staticRenderFns } from "./EdicaoAcessos.vue?vue&type=template&id=9f43ac50&"
import script from "./EdicaoAcessos.vue?vue&type=script&lang=js&"
export * from "./EdicaoAcessos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports